import React from 'react'
import { FaRegIdBadge } from 'react-icons/fa'
import {
  contentCover,
  coverHeading,
  textContainer,
} from './content-cover.module.scss'

const ContentCover = ({ children, bg, center, className }) => {
  const textCenter = center ? 'text-center' : 'default'

  return (
    <section
      className={`${textCenter} ${contentCover}`}
      style={bg ? bg : { backgroundColor: '#fff' }}
    >
      <div className={`${textContainer} ${className}`}>{children}</div>
    </section>
  )
}

export default ContentCover
